import { Box } from "@chakra-ui/react";

const Timesheets = () => <Box>Timesheets</Box>;

export default Timesheets;
